import React from 'react';
import { Empty as AEmpty } from 'antd';

export const Empty = ({ ...props }) => (<AEmpty image={AEmpty.PRESENTED_IMAGE_SIMPLE} description='No Data' { ...props} />)
